import { useMutation } from '@tanstack/react-query'
import { billingApi } from '../../utils/api'

/**
 * サブスクリプション解約（BillingPage）。
 * 成功時は現行どおり全体リロードでプランを反映する（AuthContext 再取得を含む。回帰最小化）。
 */
export function useCancelSubscription() {
  return useMutation({
    mutationFn: () => billingApi.cancelSubscription(),
    onSuccess: () => {
      window.location.reload()
    },
  })
}
